import { render } from "./SuperAdminHome.vue?vue&type=template&id=18252042"
import script from "./SuperAdminHome.vue?vue&type=script&lang=js"
export * from "./SuperAdminHome.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__